import { Button, makeStyles, Typography, TextField } from '@material-ui/core';
import React, { useState } from 'react';

import { useOrdering } from '../../../../stores/OrderingStore';

const useStyles = makeStyles(theme => ({
  submit: {
    margin: theme.spacing(2)
  }
}));

const PromotionCode = () => {
  const [promoCodeInput, setPromoCodeInput] = useState('');
  const [applyPromo, setApplyPromo] = useState(false);
  const orderingStore = useOrdering();
  const classes = useStyles();

  return (
    <>
      <TextField
        label="Promotion Code"
        margin="dense"
        variant="outlined"
        id="promo_code"
        name="promo_code"
        onChange={e => setPromoCodeInput(e.target.value)}
        InputProps={{
          endAdornment: (
            <Button
              className={classes.submit}
              color="primary"
              variant="contained"
              onClick={async () => {
                await orderingStore.applyPromoCode(promoCodeInput);
                setApplyPromo(true);
              }}
              disabled={!promoCodeInput}
            >
              APPLY
            </Button>
          )
        }}
      />
      {orderingStore.order.discount && applyPromo && (
        <Typography color="primary">Your code is accepted!</Typography>
      )}
      {!orderingStore.order.discount && applyPromo && (
        <Typography color="error">Invalid code!</Typography>
      )}
    </>
  );
};

export default PromotionCode;
